const en = {
  common: {
    ok: "OK!",
    cancel: "Cancel",
    back: "Back",
    login: "Login",
    existing: "Existing", // WH
    existingRegister: "Existing Register", // WH
    register: "Register",
    submit: "Submit",
    logOut: "Log Out", // @demo remove-current-line
    oldPin: "Old Pin Number",
    pin: "Pin Number",
    confirmPin: "Confirm Pin Number",
    verify: "Verify",
    save: "Save",
    update: "Update",
    shortFormPoint: "pts",
    male: "Male",
    female: "Female",
    genderRatherNotToSay: "Rather not to say",
    ic: "IC",
    passport: "Passport",
    dob: "DOB",
    hi: "Welcome Back, ",
    showAll: "Show all",
    completeNow: "Complete Now",
    and: "and",
    gotIt: "Got It",
    confirm: "Confirm",
    uploadSuccess: "Upload Successs",
    copiedLink: "Link copied",
    logOutSuccess: "Log out successfully",
    yes: "YES",
    no: "NO",
    shopee: "shopee",
    lazada: "lazada",
    tiktok: "tiktok",
    zalora: "zalora",
    wow: "wow",
    others: "others",
    malay: "Malay",
    chinese: "Chinese",
    india: "Indian",
    single: "single",
    married: "married",
  },
  errors: {
    invalidEmail: "Invalid email address.",
    required: "This field is required",
    pinTooShort: "6 digit pin is required",
    samePin: "Pin and confirm pin must be same",
    invalidPhoneNumber: "Invalid phone number format",
    failToShare: "Failed to share",
    noAccount: "No account was found",
    sessionExpired: "Session expired",
    failedToRedeem: "Failed to redeem voucher",
    failedToRedeemNoVoucher: "Failed to redeem voucher, there are no voucher left",
    outOfStock: "Voucher out of stock",
    failedToRetreiveVoucher: "Failed to retreive voucher",
    notEnoughPoint: "Not enough point to redeem",
    failedToUseVoucher: "Failed to use voucher",
    failedToRetreiveMember: "Failed to retreive member profile",
    failedToUpdateProfile: "Failed to update user profile",
    failedToUpload: "Failed to upload",
    failedToRetreivePromotion: "Failed to retreive promotion",
    memberNotFound: "Member not found",
    memberExceedRedeem: "Member already received this voucher before.",
    maxLength: "Entered input too long",
    enterMembershipOrPhone: "Please enter your membership number or contact number",
  },
  loginScreen: {
    title: "Login",
    phoneNumber: "Phone Number",
    phoneNumberPlaceholder: "Example: 1XXXXXXXX",
    loginSuccess: "Login Successfully",
    dontHaveAccount: "Don't have an account?",
    forgetPin: "Forget pin",
    header: "Welcome to",
    description: "Please enter your mobile number and pin number to log in",
    invalidCredential: "Invalid credential please try again",
    verifyAccount: "Please verify your account",
    failedToLogin: "Failed to login",
    contactUs: "Account inactive, please contact customer support",
    existing: "Existing LARRIE Members", // WH
    signUp: "Sign up Now", // WH
  },
  verificationScreen: {
    title: "Verification",
    headerTitle: "We want to be sure it's you",
    description: "Please enter the 4-digit code sent to",
    resend: "Request new code",
    in: "in",
    resendOTPSuccess: "Resend OTP successfully",
    resendOTPFailed: "Failed to resend OTP",
    verifySuccess: "Verify successfully",
    verifyFailed: "Failed to verify OTP",
    exceedVerifyCount: "OTP expired, please resend a new OTP",
    didntReceiveCode: "Didn't receive code?",
  },
  registerScreen: {
    title: "Member Registration",
    ic: "ID Number",
    signUp: "Sign up",
    idType: "ID Type",
    description: "Fill up the form below to create your account",
    icPlaceholder: "Example: 990909141234",
    fullName: "Full Name",
    fullNamePlaceholder: "Please enter full name",
    iHaveAccept: " I agreed to",
    tnc: "Terms & Conditions",
    privacyPolicy: "Privacy Policy",
    registerSuccess: "Register user successfully",
    registerFailed: "Failed to register user",
    registerFailedNumberExist: "This phone number is already in use.",
    referral: "referral code",
    race: "Race",
    maritalStatus: "Marital Status",
    referralCode: "Referral Code",
  },
  // WH
  existingScreen: {
    title: "Existing LARRIE Members",
    memberShipNo: "Membership No",
    contactNumber: "Contact Number",
    or: "or",
    submit: "Submit",
    memberShipNoPlaceholder: "Please enter your membership number",
    phoneNoPlaceholder: "Please enter your phone number",
    welcomeBack: "Welcome Back, Member!",
    description: "Please enter your membership number or contact number to proceed",
    selectAMethod: "Select a method to received your OTP",
  },
  existingRegisterScreen: {
    title: "Existing LARRIE Members Registration",
    updateExist: "Update Your Account Details",
    description: "Please review and update your information below.",
    update: "Update",
  },
  homeScreen: {
    title: "Home",
    incompleteProfile: "Incomplete Profile",
    completeNow: "Complete your user profile now to earn yourself a RM5 voucher",
    redeem: "Redeem",
    voucher: "Voucher",
    myPoint: "My points",
    promotions: "Promotions",
    referral: "Referral",
    pts: "pts",
    myQr: "My QR",
    tier: "Your tier",
    spend: "Spend",
    toReach: "more to reach",
    point: "pts",
    memberExclusive: "Member's exclusive",
  },
  memberQrScreen: {
    title: "My QR",
    zoomIn: "Tap on code to zoom in",
    description: "Present this code to our staff upon purchase to earn points",
    membershipNumber: "Membership number",
  },
  forgetPinScreen: {
    title: "Forget Pin",
    getStarted: "Let's get started with you phone number!",
    description: "Please enter your mobile number to reset password",
    failedToVerify: "Failed to verify phone number",
  },
  editNewPinScreen: {
    title: "Edit New Pin",
    updateSuccess: "Successfully reset pin",
    description: "Key in your new pin",
    updateFailed: "Failed to reset pin",
    passwordChanged: "Password changed!",
    loginAccountWithNewPin: "You can now log in to your account with the new password",
    pinNotSame: "Pin and Confirm Pin not same!",
  },
  memberScreen: {
    title: "Membership",
    pageTitle: "Membership Tier",
    tier: "tier",
    reachTier: "You have reached ",
    defaultTier: "Gold Tier",
    totalPoint: "Total point",
    expiringThisMonth: "Point expiring this month",
  },
  profileScreen: {
    title: "Me",
    logout: "Log Out",
  },
  editProfileScreen: {
    title: "Edit Profile",
    dobPlaceholder: "Enter date of birth",
    email: "Email",
    emailPlaceholder: "Please enter email",
    gender: "Gender",
    genderPlaceholder: "Please select gender",
    takePhoto: "Take Photo",
    uploadGallery: "Upload from gallery",
    successUpdate: "Update profile successfully",
  },
  pointHistoryScreen: {
    title: "Point History",
    pointTransactionHistory: "Point transaction history",
    yourPoint: "Your points",
    pointEarned: "Points earned",
    emptyTitle: "Point history is empty",
    emptyDescription: "Start earning points by visiting nearby store",
  },
  redeemScreen: {
    title: "Voucher",
    availablePoint: "Available points",
    point: "points",
    pts: "pts",
    voucherName: "Voucher Name",
    noVoucher: "No voucher available",
    stayTuned: "Stay tuned for more voucher coming",
  },
  employeeLoginScreen: {
    title: "Employee Login",
    password: "Password",
    passwordPlaceholder: "Please enter your password",
    company: "Company",
  },
  employeeMenuScreen: {
    uploadReceipt: "Upload Receipt",
    issueVoucher: "Issue Voucher",
    issueVoucherHistory: "Issue Voucher History",
    logout: "Log Out",
  },
  employeeUploadScreen: {
    header: "Upload Receipt",
    bothnotFound: "Invoice Number & Total Value Not Found",
    invoiceNumbernotFound: "Invoice Number Not Found",
    totalValuenotFound: "Total Value Not Found",
    invoiceNumber: "Invoice Number",
    totalValue: "Total Value",
    ok: "OK",
    modalHeader: "Upload Receipt Introduction",
    uploadSuccess: "Upload Receipt Success",
    uploadFailed: "Upload Receipt Failed",
  },
  employeeEnterUserScreen: {
    header: "Upload Receipt",
    subheader: "Enter User Phone Number",
    joinUser: "Do you like to become our member?",
  },
  employeeIssueVoucherScreen: {
    noBranch: "No branch available, please contact admin",
    title: "Issue Voucher",
    issueSuccess: "Successfully Issued Voucher",
    branch: "Branch",
    branchPlaceholder: "Please select a branch",
    employeeName: "Employee name",
    memberCode: "Member Code",
    memerCodePlaceholdeer: "Please input/scan member code",
    voucher: "Voucher",
    voucherPlaceholder: "Please select a voucher",
  },
  employeeIssueVoucherHistoryScreen: {
    title: "Issued Voucher History",
    customerName: "Customer Name",
    outletName: "Outlet Name",
    issuedOn: "Issued On",
    voucherName: "Voucher Name",
    searchPlaceholder: "Customer / Outlet / Voucher Name",
    noVoucherIssued: "No voucher issued yet!",
  },
  promotionScreen: {
    title: "Promotion",
    noPromotion: "No ongoing promotions available",
    stayTuned: "Stay tuned for more promotions coming",
    promotionName: "Promotion Name",
    noNotification: "No Notification available",
    stayTunedNoti: "Stay tuned for more notification coming",
  },
  promotionDetailScreen: {
    howToRedeem: "How to redeem",
    tnc: "Terms & Condition",
    claimVoucher: "Claim Voucher",
  },
  referralScreen: {
    title: "Referral",
    inviteFriend: "Invite your friend and get rewarded",
    point: "points",
    earn: "Earn",
    eachFriend: "for each friends who joined with your code.",
    copiedToClipboard: "Referral code copied to clipboard!",
    copyReferralDescription:
      "Copy your referral code, or share it to your friend on the social media",
    yourRefferal: "Your referral code",
  },
  voucherScreen: {
    title: "My Rewards",
    history: "Rewards History",
    cannotFindVoucher: "Can’t find your rewards?",
    try: "Try",
    searchHistory: "searching the history",
    voucherRedeemed: "Rewards redeemed",
    checkVoucher: "Check Rewards",
    findVoucher: "You will be able to find this rewards in your rewards list.",
    expiry: "Expiry Date",
    usedOn: "Used On",
    expiredOn: "Expired On",
    noVoucher: "No voucher available yet",
  },
  voucherDetailScreen: {
    useVoucher: "Use Now",
    howToUse: "How to use",
    dontClickVoucher: "Don’t click unless you’re ready to use this voucher",
    voucherUsed: "Voucher Used",
    redeem: "Redeem",
    claim: "Claim",
    use: "Use Now",
    redeemSuccesfully: "Redeem Successfully",
    useVoucherSuccessfully: "Voucher Successfully Used",
    redeemLater: "Redeem Later",
    useLater: "Use Later",
    areYouSureRedeem: "Are you sure you want to redeem?",
    areYouSureUse: "Are you sure you want to use?",
    enjoyDeals: "Present this QR code to the staff to enjoy the deal",
    expiredIn: "QR code will expired in",
    usedOn: "You used this voucher on ",
    expiredOn: "This voucher has expired on ",
    expiredOnstamp: "This stamp has expired on ",
    pickPlatform: "Please pick a platform",

    dontClickCoupon: "Don’t click unless you’re ready to use",
    useCoupon: "Use Now",
    clickToShowBarCode: "Click QR/barcode swap to show",
  },
  uploadReceiptScreen: {
    header: "Upload Receipt",
    bothnotFound: "Invoice Number & Total Value Not Found",
    invoiceNumbernotFound: "Invoice Number Not Found",
    totalValuenotFound: "Total Value Not Found",
    invoiceNumber: "Invoice Number",
    totalValue: "Total Value",
    ok: "OK",
    modalHeader: "Upload Receipt Introduction",
    uploadSuccess: "Upload Receipt Success",
    uploadFailed: "Upload Receipt Failed",
    platform: "Platform",
  },
  memberShipScreen: {
    header: "Membership Benefit",
  },
  feedBackScreen: {
    successUpload: "Feedback submit Successfully",
    failedUpload: "Failed to submit feedback",
  },
  rewardScreen: {
    title: "My Rewards",
    history: "Rewards History",
    cannotFindVoucher: "Can’t find your rewards?",
    try: "Try",
    searchHistory: "searching the history",
    voucherRedeemed: "Voucher redeemed",
    checkVoucher: "Check Voucher",
    findVoucher: "You will be able to find this voucher in your voucher list.",
    expiry: "Expiry Date",
    usedOn: "Used On",
    expiredOn: "Expired On",
    noVoucher: "No rewards",
  },
  foryouScreen: {
    title: "For You",
    history: "Coupon History",
    cannotFindVoucher: "Can’t find your Coupon?",
    try: "Try",
    searchHistory: "searching the history",
    voucherRedeemed: "Voucher redeemed",
    checkVoucher: "Check Voucher",
    findVoucher: "You will be able to find this voucher in your voucher list.",
    expiry: "Expiry Date",
    usedOn: "Used On",
    expiredOn: "Expired On",
    noVoucher: "No Coupon at this moment",
  },
}

export default en
export type Translations = typeof en
